export default function _storeResolvedCaches (resolvedCaches) {
  return {
    type: 'DATA_CONNECTOR_STORE_RESOLVED_CACHES',
    payload: resolvedCaches,
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/_storeResolvedCaches.js